export interface PortalMaintenancePayload {
  resolutionStatus?: string;
  maintenance?: {
    isEnabled?: boolean;
    message?: string | null;
  } | null;
}

const PORTAL_CONTEXT_MAINTENANCE_STATUSES = new Set([
  "resolution_error",
  "missing_brand",
]);

export const shouldShowPortalMaintenance = (payload: PortalMaintenancePayload | null | undefined): boolean => {
  if (!payload) {
    return false;
  }

  if (payload.maintenance?.isEnabled === true) {
    return true;
  }

  const resolutionStatus = payload.resolutionStatus?.trim().toLowerCase() ?? "";
  return PORTAL_CONTEXT_MAINTENANCE_STATUSES.has(resolutionStatus);
};

export const getPortalMaintenanceMessage = (payload: PortalMaintenancePayload | null | undefined): string =>
  payload?.maintenance?.message?.trim() ||
  "FamilySafe is currently unavailable while we carry out essential work on the platform.";
